import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { toastErrorMessage, toastSuccessMessage } from "../utils/utils";
import { changePasswordSchema } from "../validators/validatorSchema";
import { validateData, clearError } from "../validators/YupValidations";
import { useNavigate } from "react-router-dom";

// ⬆️ Reusable Field Wrapper (same as Edit Profile)
const Field = ({ label, required, children, error }) => (
  <div className="mb-3 pb-1">
    <label className="form-label small mb-2">
      {label} {required && <span className="text-danger">*</span>}
    </label>

    {children}

    {error && <div className="text-danger small mt-1">{error}</div>}
  </div>
);

function ChangePassword() {
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });

    if (errors[field]) clearError(setErrors, field); // clear field error
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = await validateData(changePasswordSchema, form, setErrors);
    if (!isValid) return;

    try {
      setLoading(true);

      const res = await API.post(api_paths.member.CHANGE_PASSWORD, {
        old_password: form.old_password,
        new_password: form.new_password,
        confirm_password: form.confirm_password,
      });

      toastSuccessMessage(
        res.data?.message || "Password updated successfully!"
      );

      navigate(-1);

      setForm({
        old_password: "",
        new_password: "",
        confirm_password: "",
      });
    } catch (error) {
      toastErrorMessage(
        error.response?.data?.message || "Failed to update password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="w-100 d-flex justify-content-center"
      style={{ background: "#F7F7F7", minHeight: "100vh" }}
    >
      <div className="p-4" style={{ width: "700px", background: "#FFFFFF" }}>
        <h4 className="mb-4">Change Password</h4>

        <Form onSubmit={handleSubmit}>
          {/* OLD PASSWORD */}
          <Field
            label="Old Password"
            required
            error={errors.old_password?.message}
          >
            <Form.Control
              type="password"
              placeholder="Enter Old Password"
              value={form.old_password}
              onChange={(e) => handleChange("old_password", e.target.value)}
              className={errors.old_password ? "is-invalid" : ""}
            />
          </Field>

          {/* NEW PASSWORD */}
          <Field
            label="New Password"
            required
            error={errors.new_password?.message}
          >
            <Form.Control
              type="password"
              placeholder="Enter New Password"
              value={form.new_password}
              onChange={(e) => handleChange("new_password", e.target.value)}
              className={errors.new_password ? "is-invalid" : ""}
            />
          </Field>

          {/* CONFIRM PASSWORD */}
          <Field
            label="Confirm Password"
            required
            error={errors.confirm_password?.message}
          >
            <Form.Control
              type="password"
              placeholder="Enter Confirm Password"
              value={form.confirm_password}
              onChange={(e) => handleChange("confirm_password", e.target.value)}
              className={errors.confirm_password ? "is-invalid" : ""}
            />
          </Field>

          <Button
            type="submit"
            className="btn btn-orange-lg"
            style={{ padding: "8px 26px" }}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Update"}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ChangePassword;
